/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * RapidWorks REST API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddTicketRecurrenceInput,
  CreateSingleRaptorJobInput,
  GetApiV3RaptorJobsIdParams,
  GetApiV3RaptorJobsParams,
  JobStatusDto,
  PagedResultOfRaptorJobDto,
  PostApiV3RaptorJobsCreateJobParams,
  PostApiV3RaptorJobsCreateSingleDayJobParams,
  PostApiV3RaptorJobsIdCancelParams,
  ProblemDetails,
  PutApiV3RaptorJobsIdParams,
  RaptorJobDto,
  RaptorTicketDto,
  UpdateRaptorJobInput,
  UpdateRaptorJobStatusInput
} from '.././model';

import { axiosInstance } from '../../axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Gets all RaptorJobs including legacy jobs with filtering, sorting, and pagination.
Each job includes RequirementsCount (total permit/certificate requirements) and RequirementsMet (e.g. "3/5").
 */
export const getApiV3RaptorJobs = (
  params?: GetApiV3RaptorJobsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PagedResultOfRaptorJobDto>({ url: `/api/v3/raptor-jobs`, method: 'GET', params, signal }, options);
};

export const getGetApiV3RaptorJobsQueryKey = (params?: GetApiV3RaptorJobsParams) => {
  return [`/api/v3/raptor-jobs`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3RaptorJobsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError = ProblemDetails | void>(
  params?: GetApiV3RaptorJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3RaptorJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3RaptorJobs>>> = ({ signal }) =>
    getApiV3RaptorJobs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiV3RaptorJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV3RaptorJobs>>>;
export type GetApiV3RaptorJobsQueryError = ProblemDetails | void;

export function useGetApiV3RaptorJobs<TData = Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError = ProblemDetails | void>(
  params: undefined | GetApiV3RaptorJobsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, Awaited<ReturnType<typeof getApiV3RaptorJobs>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobs<TData = Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError = ProblemDetails | void>(
  params?: GetApiV3RaptorJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, Awaited<ReturnType<typeof getApiV3RaptorJobs>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobs<TData = Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError = ProblemDetails | void>(
  params?: GetApiV3RaptorJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets all RaptorJobs including legacy jobs with filtering, sorting, and pagination.
Each job includes RequirementsCount (total permit/certificate requirements) and RequirementsMet (e.g. "3/5").
 */

export function useGetApiV3RaptorJobs<TData = Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError = ProblemDetails | void>(
  params?: GetApiV3RaptorJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3RaptorJobsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets a single RaptorJob by ID.
 */
export const getApiV3RaptorJobsId = (
  id: number,
  params?: GetApiV3RaptorJobsIdParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorJobDto>({ url: `/api/v3/raptor-jobs/${id}`, method: 'GET', params, signal }, options);
};

export const getGetApiV3RaptorJobsIdQueryKey = (id?: number, params?: GetApiV3RaptorJobsIdParams) => {
  return [`/api/v3/raptor-jobs/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3RaptorJobsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3RaptorJobsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  params?: GetApiV3RaptorJobsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3RaptorJobsIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>> = ({ signal }) =>
    getApiV3RaptorJobsId(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3RaptorJobsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3RaptorJobsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>>;
export type GetApiV3RaptorJobsIdQueryError = ProblemDetails | void;

export function useGetApiV3RaptorJobsId<TData = Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError = ProblemDetails | void>(
  id: number,
  params: undefined | GetApiV3RaptorJobsIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsId<TData = Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError = ProblemDetails | void>(
  id: number,
  params?: GetApiV3RaptorJobsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3RaptorJobsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3RaptorJobsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3RaptorJobsId<TData = Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError = ProblemDetails | void>(
  id: number,
  params?: GetApiV3RaptorJobsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets a single RaptorJob by ID.
 */

export function useGetApiV3RaptorJobsId<TData = Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError = ProblemDetails | void>(
  id: number,
  params?: GetApiV3RaptorJobsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3RaptorJobsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3RaptorJobsIdQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates an existing RaptorJob.
 */
export const putApiV3RaptorJobsId = (
  id: number,
  updateRaptorJobInput: UpdateRaptorJobInput,
  params?: PutApiV3RaptorJobsIdParams,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<RaptorJobDto>(
    {
      url: `/api/v3/raptor-jobs/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateRaptorJobInput,
      params
    },
    options
  );
};

export const getPutApiV3RaptorJobsIdMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3RaptorJobsId>>,
    TError,
    { id: number; data: UpdateRaptorJobInput; params?: PutApiV3RaptorJobsIdParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiV3RaptorJobsId>>,
  TError,
  { id: number; data: UpdateRaptorJobInput; params?: PutApiV3RaptorJobsIdParams },
  TContext
> => {
  const mutationKey = ['putApiV3RaptorJobsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiV3RaptorJobsId>>,
    { id: number; data: UpdateRaptorJobInput; params?: PutApiV3RaptorJobsIdParams }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return putApiV3RaptorJobsId(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3RaptorJobsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV3RaptorJobsId>>>;
export type PutApiV3RaptorJobsIdMutationBody = UpdateRaptorJobInput;
export type PutApiV3RaptorJobsIdMutationError = ProblemDetails | void;

/**
 * @summary Updates an existing RaptorJob.
 */
export const usePutApiV3RaptorJobsId = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3RaptorJobsId>>,
      TError,
      { id: number; data: UpdateRaptorJobInput; params?: PutApiV3RaptorJobsIdParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiV3RaptorJobsId>>,
  TError,
  { id: number; data: UpdateRaptorJobInput; params?: PutApiV3RaptorJobsIdParams },
  TContext
> => {
  const mutationOptions = getPutApiV3RaptorJobsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancels a RaptorJob.
 */
export const postApiV3RaptorJobsIdCancel = (
  id: number,
  params?: PostApiV3RaptorJobsIdCancelParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorJobDto>({ url: `/api/v3/raptor-jobs/${id}/cancel`, method: 'POST', params, signal }, options);
};

export const getPostApiV3RaptorJobsIdCancelMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>,
    TError,
    { id: number; params?: PostApiV3RaptorJobsIdCancelParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>,
  TError,
  { id: number; params?: PostApiV3RaptorJobsIdCancelParams },
  TContext
> => {
  const mutationKey = ['postApiV3RaptorJobsIdCancel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>,
    { id: number; params?: PostApiV3RaptorJobsIdCancelParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return postApiV3RaptorJobsIdCancel(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3RaptorJobsIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>>;

export type PostApiV3RaptorJobsIdCancelMutationError = ProblemDetails | void;

/**
 * @summary Cancels a RaptorJob.
 */
export const usePostApiV3RaptorJobsIdCancel = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>,
      TError,
      { id: number; params?: PostApiV3RaptorJobsIdCancelParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3RaptorJobsIdCancel>>,
  TError,
  { id: number; params?: PostApiV3RaptorJobsIdCancelParams },
  TContext
> => {
  const mutationOptions = getPostApiV3RaptorJobsIdCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Updates the status of a RaptorJob (legacy only).
Uses direct SQL to bypass EF Core concurrency issues with the PourForAdding_UTrig trigger.
The trigger handles side effects: CancelDate, OldStatus, JobHistory, Crew reset, etc.
 */
export const patchApiV3RaptorJobsIdUpdateStatus = (
  id: number,
  updateRaptorJobStatusInput: UpdateRaptorJobStatusInput,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<JobStatusDto>(
    {
      url: `/api/v3/raptor-jobs/${id}/update-status`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateRaptorJobStatusInput
    },
    options
  );
};

export const getPatchApiV3RaptorJobsIdUpdateStatusMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>,
    TError,
    { id: number; data: UpdateRaptorJobStatusInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>,
  TError,
  { id: number; data: UpdateRaptorJobStatusInput },
  TContext
> => {
  const mutationKey = ['patchApiV3RaptorJobsIdUpdateStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>,
    { id: number; data: UpdateRaptorJobStatusInput }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchApiV3RaptorJobsIdUpdateStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiV3RaptorJobsIdUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>>;
export type PatchApiV3RaptorJobsIdUpdateStatusMutationBody = UpdateRaptorJobStatusInput;
export type PatchApiV3RaptorJobsIdUpdateStatusMutationError = ProblemDetails | void;

/**
 * @summary Updates the status of a RaptorJob (legacy only).
Uses direct SQL to bypass EF Core concurrency issues with the PourForAdding_UTrig trigger.
The trigger handles side effects: CancelDate, OldStatus, JobHistory, Crew reset, etc.
 */
export const usePatchApiV3RaptorJobsIdUpdateStatus = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>,
      TError,
      { id: number; data: UpdateRaptorJobStatusInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiV3RaptorJobsIdUpdateStatus>>,
  TError,
  { id: number; data: UpdateRaptorJobStatusInput },
  TContext
> => {
  const mutationOptions = getPatchApiV3RaptorJobsIdUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Creates a single day RaptorJob with resources, estimates, and custom fields.
 */
export const postApiV3RaptorJobsCreateSingleDayJob = (
  createSingleRaptorJobInput: CreateSingleRaptorJobInput,
  params?: PostApiV3RaptorJobsCreateSingleDayJobParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorJobDto>(
    {
      url: `/api/v3/raptor-jobs/create-single-day-job`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSingleRaptorJobInput,
      params,
      signal
    },
    options
  );
};

export const getPostApiV3RaptorJobsCreateSingleDayJobMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>,
    TError,
    { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateSingleDayJobParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>,
  TError,
  { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateSingleDayJobParams },
  TContext
> => {
  const mutationKey = ['postApiV3RaptorJobsCreateSingleDayJob'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>,
    { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateSingleDayJobParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiV3RaptorJobsCreateSingleDayJob(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3RaptorJobsCreateSingleDayJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>
>;
export type PostApiV3RaptorJobsCreateSingleDayJobMutationBody = CreateSingleRaptorJobInput;
export type PostApiV3RaptorJobsCreateSingleDayJobMutationError = ProblemDetails | void;

/**
 * @summary Creates a single day RaptorJob with resources, estimates, and custom fields.
 */
export const usePostApiV3RaptorJobsCreateSingleDayJob = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>,
      TError,
      { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateSingleDayJobParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3RaptorJobsCreateSingleDayJob>>,
  TError,
  { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateSingleDayJobParams },
  TContext
> => {
  const mutationOptions = getPostApiV3RaptorJobsCreateSingleDayJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Creates a RaptorJob that supports multi-day jobs.
For multi-day jobs, EndDate must be provided and must be greater than StartDate.
 */
export const postApiV3RaptorJobsCreateJob = (
  createSingleRaptorJobInput: CreateSingleRaptorJobInput,
  params?: PostApiV3RaptorJobsCreateJobParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorJobDto>(
    {
      url: `/api/v3/raptor-jobs/create-job`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSingleRaptorJobInput,
      params,
      signal
    },
    options
  );
};

export const getPostApiV3RaptorJobsCreateJobMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>,
    TError,
    { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateJobParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>,
  TError,
  { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateJobParams },
  TContext
> => {
  const mutationKey = ['postApiV3RaptorJobsCreateJob'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>,
    { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateJobParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiV3RaptorJobsCreateJob(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3RaptorJobsCreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>>;
export type PostApiV3RaptorJobsCreateJobMutationBody = CreateSingleRaptorJobInput;
export type PostApiV3RaptorJobsCreateJobMutationError = ProblemDetails | void;

/**
 * @summary Creates a RaptorJob that supports multi-day jobs.
For multi-day jobs, EndDate must be provided and must be greater than StartDate.
 */
export const usePostApiV3RaptorJobsCreateJob = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>,
      TError,
      { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateJobParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3RaptorJobsCreateJob>>,
  TError,
  { data: CreateSingleRaptorJobInput; params?: PostApiV3RaptorJobsCreateJobParams },
  TContext
> => {
  const mutationOptions = getPostApiV3RaptorJobsCreateJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Adds a ticket recurrence to a Raptor job.
This is a Raptor-only operation that allows for the creation of a single ticket or a recurrence in cases of multi-day jobs.
 */
export const postApiV3RaptorJobsJobIdAddTicketRecurrence = (
  jobId: number,
  addTicketRecurrenceInput: AddTicketRecurrenceInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RaptorTicketDto>(
    {
      url: `/api/v3/raptor-jobs/${jobId}/add-ticket-recurrence`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addTicketRecurrenceInput,
      signal
    },
    options
  );
};

export const getPostApiV3RaptorJobsJobIdAddTicketRecurrenceMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>,
    TError,
    { jobId: number; data: AddTicketRecurrenceInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>,
  TError,
  { jobId: number; data: AddTicketRecurrenceInput },
  TContext
> => {
  const mutationKey = ['postApiV3RaptorJobsJobIdAddTicketRecurrence'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>,
    { jobId: number; data: AddTicketRecurrenceInput }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return postApiV3RaptorJobsJobIdAddTicketRecurrence(jobId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3RaptorJobsJobIdAddTicketRecurrenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>
>;
export type PostApiV3RaptorJobsJobIdAddTicketRecurrenceMutationBody = AddTicketRecurrenceInput;
export type PostApiV3RaptorJobsJobIdAddTicketRecurrenceMutationError = ProblemDetails | void;

/**
 * @summary Adds a ticket recurrence to a Raptor job.
This is a Raptor-only operation that allows for the creation of a single ticket or a recurrence in cases of multi-day jobs.
 */
export const usePostApiV3RaptorJobsJobIdAddTicketRecurrence = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>,
      TError,
      { jobId: number; data: AddTicketRecurrenceInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3RaptorJobsJobIdAddTicketRecurrence>>,
  TError,
  { jobId: number; data: AddTicketRecurrenceInput },
  TContext
> => {
  const mutationOptions = getPostApiV3RaptorJobsJobIdAddTicketRecurrenceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
